import { SelectDateTime } from '~/routes';
import { envConfigSelectors } from '~/selectors';

export const config = {
  SelectDate: {
    componentDecisioner: [
      {
        supports: envConfigSelectors.selectIsNewCalendarEnabled,
        component: SelectDateTime,
      },
    ],
  },
};
